import {P_LIST_TYPES} from '../../../constants/typesMessages';

export const selectMessage = (partnersTypeList) => {
  switch (partnersTypeList) {
    case P_LIST_TYPES.P_EMPTY:
      return 'Por favor, vou precisar que você me informe alguns dados dessas pessoas, tá bem?';

    case P_LIST_TYPES.P_OWNER:
      return 'Bacana, continuando com seu credenciamento, irei precisar de algumas informações sobre os seus documentos.';

    case P_LIST_TYPES.P_OWN_HAS_PART:
      return 'Também vou precisar de algumas informações dessas pessoas, tá bem?';

    default:
      return 'Bacana, continuando com seu credenciamento, irei precisar de algumas informações sobre os documentos dos sócios ou sócias.';
  }
};
